import React, { Component } from 'react'
import Image from './image'
import { Image as ImagePb } from '../../rpc/admin/image_pb';

interface ImageListProps {
    images: Array<ImagePb>;
    disabled?: boolean;
    onChange?: (values: Array<ImagePb>) => void;
}

interface ImageListState {}

class ImageList extends Component<ImageListProps, ImageListState> {

    constructor(props: ImageListProps) {
        super(props);
        this.state = {
            cards: []
        };
    }

    private moveImage = (from: number, to: number) => {
        const updated: Array<ImagePb> = [];
        for (let i = 0; i < this.props.images.length; i++) {
            updated.push(this.props.images[i]);
        }
        const card = updated[from];
        updated[from] = updated[to];
        updated[to] = card;
        if (this.props.onChange) {
            this.props.onChange(updated);
        }
    }

    private deleteImage = (index: number) => {
        const updated: Array<ImagePb> = [];
        for (let i = 0; i < this.props.images.length; i++) {
            if (i !== index) {
                updated.push(this.props.images[i]);
            }
        }
        if (this.props.onChange) {
            this.props.onChange(updated);
        }
    }

    render() {
        const disabled = this.props.disabled || false;
		return (
			<div className="image-list">
				{this.props.images.map((image, i) => (
					<Image
						key={image.getPath()}
						index={i}
						id={image.getPath()}
						image={image}
                        moveImage={this.moveImage}
                        disabled={disabled}
                        deleteImage={this.deleteImage}
					/>
				))}
			</div>
		);
	}
}

export default ImageList